"use client";

/**
 * TextButtonComponent
 * Flexible section component for displaying text and/or a button
 */

import { LandingPageComponent } from "@/features/landing-pages/_logic/types";
import SmartButton from "../../shared/SmartButton";

interface TextButtonComponentProps {
  component: LandingPageComponent;
  eventId: number;
  primaryColor: string;
}

export default function TextButtonComponent({ component, eventId, primaryColor }: TextButtonComponentProps) {
  const title = component.config.title;
  const description = component.config.description;
  const buttonText = component.config.buttonText;
  const buttonLink = component.config.buttonLink;

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        {/* Title */}
        {title && (
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}DD 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {title}
          </h2>
        )}

        {/* Description */}
        {description && (
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto whitespace-pre-line">{description}</p>
        )}

        {/* Button - only render if both text and link are provided */}
        {buttonText && buttonLink && (
          <SmartButton
            href={buttonLink}
            text={buttonText}
            primaryColor={primaryColor}
            eventId={eventId}
            nextSteps={component.config.nextSteps}
          />
        )}
      </div>
    </section>
  );
}
